import { closePopupHelper, openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

import type { CancelAutoRenewFamilyModalProps } from './CancelAutoRenewFamilyModal.types';

export const renderCancelAutoRenewFamilyModal = ({ onClose, ...data }: CancelAutoRenewFamilyModalProps) =>
    openPopupHelper({ popupName: popupNames.SUBSCRIPTION_CANCEL_FAMILY, data, onClose });

export const closeCancelAutoRenewFamilyModal = () => closePopupHelper(popupNames.SUBSCRIPTION_CANCEL_FAMILY);
